var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panel',{attrs:{"title":"Komentarz dotyczący edycji dokumentu"}},[_c('w-textarea',{staticClass:"form-group",attrs:{"model":_vm.model}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }